import {Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import {ApiRestServiceRichieste} from "../api-rest.service-richieste";
import {TestiService} from "../config/testi.service";
import {Mail} from "../../entities/Mail";
import {MailWelcome} from "../../entities/MailWelcome";
import {Utente} from "../../entities/Utente";
import {ApiRestServiceAnagrafiche} from "../api-rest.service-anagrafiche";
import {ApiRestServicePortal} from "./api-rest.service-portal";


@Injectable({
  providedIn: 'root'
})
export class MailService {

    testi;

    constructor(private testiService: TestiService,
                private apiRestService: ApiRestServiceRichieste,
                private portalRestService: ApiRestServicePortal) {
        this.testi = this.testiService.componentRichieste;
    }

    getCurrentDateTime(): string{
        let today = new Date();
        let dd = String(today. getDate()). padStart(2, '0');
        let mm = String(today. getMonth() + 1). padStart(2, '0');
        let yyyy = today. getFullYear();
        let hh = today.getHours();
        let min = today.getMinutes();
        return dd + "/" + mm + "/" + yyyy + " " + hh + ":" + min;
    }

    sendWelcomeMail(utente: Utente, password: string): Observable<Mail> {
        const url = `mail/sendmail`;
        const model = new MailWelcome({
            "password":password,
            "portale": this.portalRestService.portalName,
            "url": this.portalRestService.portalUrl,
            "userdata": utente.firstName + " " + utente.lastName,
            "username": utente.username,
            "mail": utente.email,
            "date": this.getCurrentDateTime()
        });
        const mail = new Mail({
            "mailTo": [utente.email],
            "templateType": "welcome",
            "mailSubject": this.testi.welcomeMailOggetto,
            "model": model.getOggCreate(),
        });
        return this.apiRestService.postWithBodyAlt(url, mail.getOggCreate())
    }
}
